import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { filter, Observable, switchMap, tap } from 'rxjs';
import { AuthApiService } from '@rillion/auth/services';
import { AppSettingsService } from '@rillion/core';
import { Store } from '@ngrx/store';
import { Userpilot } from 'userpilot';

/**
 * The guard that will watch over routes for unathorized access
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  /**
   * Initializing the guard and required services
   */
  constructor(
    private readonly store: Store,
    private router: Router,
    private authApiService: AuthApiService,
    private appSettingsService: AppSettingsService,
  ) {}

  /**
   * Function that will check if user can activate a specific page
   * @param route activated route snapshot that is requested
   * @param state router state
   * @returns true/false, or Observable<boolean>, depending on the outcome
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authApiService.isDoneLoading$.pipe(
      filter((isDoneLoading) => isDoneLoading),
      switchMap((_) => this.authApiService.isAuthenticatedSubject$),
      tap((isAuthenticated) => (isAuthenticated ? Userpilot.reload() : this.authApiService.login(state.url))),
    );
    // if (this.isAccessPage(state)) {
    //   return of(true);
    // }
    // return this.store.select(AuthSelectors.selectUser).pipe(
    //   filter((user) => !!user),
    //   map((user) => {
    //     try {
    //       if (user.token) {
    //         Userpilot.reload();
    //         return true;
    //       }
    //       return false;
    //     } catch (error) {
    //       return false;
    //     }
    //   }),
    // );
  }

  /**
   * Checking if the page is access page
   * @param state Router state
   * @returns true/false
   */
  private isAccessPage(state: RouterStateSnapshot): boolean {
    return this.isLoginPage(state) || this.isResetPasswordPage(state) || this.isRegisterPage(state);
  }

  /**
   * Checking if page is login page
   * @param state Router state
   * @returns true/false
   */
  private isLoginPage(state: RouterStateSnapshot): boolean {
    return state.url.startsWith(this.appSettingsService.appSettings.loginRedirectUrl);
  }

  /**
   * Checking if page is reset password page
   * @param state Router state
   * @returns true/false
   */
  private isResetPasswordPage(state: RouterStateSnapshot): boolean {
    return state.url.startsWith('/reset-password');
  }

  /**
   * Checking if page is register page
   * @param state Router state
   * @returns true/false
   */
  private isRegisterPage(state: RouterStateSnapshot): boolean {
    return state.url.startsWith('/register');
  }
}
